import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { City } from 'src/app/shared/interfaces/city';
import { Counting } from 'src/app/shared/interfaces/counting';
import { HealthCare } from 'src/app/shared/interfaces/health-care';
import { Service } from 'src/app/shared/interfaces/service';
import { Subservice } from 'src/app/shared/interfaces/subservice';
import { UsbService } from 'src/app/shared/interfaces/usb-service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HCService {

    constructor(private _HttpClient: HttpClient) { }

    getPindingHealthCare(): Observable<Service[]> {
        return this._HttpClient.get<Service[]>(environment.baseUrl + 'admin/get-pending-health-care')
    }

    getPindingHealthCareDetails(id: string): Observable<Service[]> {
        return this._HttpClient.get<Service[]>(environment.baseUrl + `admin/get-peding-health-care-id/${id}`)
    }

    getAllHealthCare(): Observable<Service[]> {
        return this._HttpClient.get<Service[]>(environment.baseUrl + 'admin/get-health-care')
    }

    getServicesDetails(id: string): Observable<Service[]> {
        return this._HttpClient.get<Service[]>(environment.baseUrl + `shared/get-service/${id}`)
    }

    addService(formData: any): Observable<Service[]> {
        return this._HttpClient.post<Service[]>(environment.baseUrl + 'health-care/add-service', formData);
    }

    addServiceToHc(formData: any): Observable<UsbService[]> {
        return this._HttpClient.post<UsbService[]>(environment.baseUrl + 'admin/add-usb-service-for-hc', formData);
    }

    getCities(): Observable<City[]> {
        return this._HttpClient.get<City[]>(environment.baseUrl + 'shared/get-cities')
    }

    creatHealthCare(formData: any): Observable<Service[]> {
        return this._HttpClient.post<Service[]>(environment.baseUrl + 'admin/create-health-care', formData);
    }

    approveHealthCare(formData: any): Observable<Service[]> {
        return this._HttpClient.post<Service[]>(environment.baseUrl + 'admin/approved-health-care', formData);
    }

    disableHealthCare(formData: any): Observable<Service[]> {
        return this._HttpClient.post<Service[]>(environment.baseUrl + 'admin/disable-health-care', formData);
    }

    updateHealthCare(formData: any): Observable<Service[]> {
        return this._HttpClient.post<Service[]>(environment.baseUrl + 'admin/update-health-care', formData);
    }

    getHealthCareDetails(id: string): Observable<Counting[]> {
        return this._HttpClient.get<Counting[]>(environment.baseUrl + `admin/get-health-care-id/${id}`)
    }

    getHealthCareCountingDetails(id: object): Observable<Counting[]> {
        return this._HttpClient.get<Counting[]>(environment.baseUrl + `admin/get-healthcare-counting/${id}`)
    }

    getHealthCareServices(id: string): Observable<any> {
        return this._HttpClient.get(environment.baseUrl + `admin/get-hc-servies/${id}`)
    }

    getHealthSubServices(id: string): Observable<Subservice[]> {
        return this._HttpClient.get<Subservice[]>(environment.baseUrl + `shared/get-sub-service/${id}`)
    }

    getHealthCareZone(id: string): Observable<HealthCare[]> {
        return this._HttpClient.get<HealthCare[]>(environment.baseUrl + `admin/get-health-zones/${id}`)
    }

    updateHcService(formData: any): Observable<any> {
        return this._HttpClient.post<any>(environment.baseUrl + 'admin/update-hc-service', formData);
    }
}
